export default [
    {
        path: '/settings/account',
        name: 'Account',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Account',
        },
        components: {
            default: () => import('@/views/settings/AccountSettings.vue'),
        },
    },
    {
        path: '/settings/global',
        name: 'GlobalSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER'],
            denyRoles: null,
            title: 'Global settings',
        },
        components: {
            default: () => import('@views/settings/GlobalSettings.vue'),
        },
    },
    {
        path: '/settings',
        name: 'TenantSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Settings',
        },
        components: {
            default: () => import('@views/settings/Settings.vue'),
        },
    },
    {
        path: '/settings/company',
        name: 'CompanySettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Company settings',
        },
        components: {
            default: () => import('@views/settings/CompanySettings.vue'),
        },
    },
    {
        path: '/settings/legal',
        name: 'LegalSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Legal settings',
        },
        components: {
            default: () => import('@views/settings/LegalSettings.vue'),
        },
    },
    {
        path: '/settings/booking',
        name: 'BookingSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Booking settings',
        },
        components: {
            default: () => import('@views/settings/BookingSettings.vue'),
        },
    },
    {
        path: '/settings/transport',
        name: 'TransportSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Transport settings',
        },
        components: {
            default: () => import('@views/settings/TransportSettings.vue'),
        },
    },
    {
        path: '/settings/integrations',
        name: 'IntegrationsSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Integrations settings',
        },
        components: {
            default: () => import('@views/settings/IntegrationsSettings.vue'),
        },
    },
    {
        path: '/settings/pricing',
        name: 'PricingSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Pricing settings',
        },
        components: {
            default: () => import('@views/settings/PricingSettings.vue'),
        },
    },
    {
        path: '/settings/payments',
        name: 'StripeSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Payment settings',
        },
        components: {
            default: () => import('@views/settings/StripeSettings.vue'),
        },
    },
    {
        path: '/settings/tracking',
        name: 'TrackingSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Tracking settings',
        },
        components: {
            default: () => import('@views/settings/TrackingSettings.vue'),
        },
    },
    {
        path: '/settings/telecommunications',
        name: 'TelcoSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Telecommunications',
        },
        components: {
            default: () => import('@views/settings/TelcoSettings.vue'),
        },
    },
    {
        path: '/settings/security',
        name: 'SecuritySettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Security settings',
        },
        components: {
            default: () => import('@views/settings/SecuritySettings.vue'),
        },
    },
    {
        path: '/settings/communications',
        name: 'CommunicationsSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN', 'MANAGER'],
            denyRoles: null,
            title: 'Communications settings',
        },
        components: {
            default: () => import('@views/settings/CommunicationsSettings.vue'),
        },
    },
    {
        path: '/settings/ai',
        name: 'AiSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'AI settings',
        },
        components: {
            default: () => import('@views/settings/TenantAiSettings.vue'),
        },
    },
    {
        path: '/settings/fix-list',
        name: 'FixListSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Fix list settings',
        },
        components: {
            default: () => import('@views/settings/FixListSettings.vue'),
        },
    },
    {
        path: '/settings/notifications',
        name: 'NotificationsSettings',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN'],
            denyRoles: null,
            title: 'Notifications settings',
        },
        components: {
            default: () => import('@views/settings/NotificationsSettings.vue'),
        },
    },
];
